"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYABLE_VIDEO_CARD_TYPES = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = require("lodash");
var inline_icon_1 = tslib_1.__importDefault(require("../../../../../ui-components/inline-icon/inline-icon"));
var ScheduledIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/ScheduledIcon"));
var SparkIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/SparkIcon"));
var TagIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/TagIcon"));
var TriangleIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/TriangleIcon"));
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
exports.PLAYABLE_VIDEO_CARD_TYPES = [
    types_1.VIDEO_CARD_TYPES.VIDEO,
    types_1.VIDEO_CARD_TYPES.RECENT_VIDEO,
    types_1.VIDEO_CARD_TYPES.CHANNEL,
];
var CardThumbnailPlaceholderIcon = function (_a) {
    var _b;
    var type = _a.type, thumbnailUrl = _a.thumbnailUrl, itemType = _a.itemType;
    if (itemType === item_type_1.ItemType.ItemScheduled) {
        return thumbnailUrl ? null : (react_1.default.createElement(inline_icon_1.default, { className: styles_scss_1.default['icon-scheduled'], icon: react_1.default.createElement(ScheduledIcon_1.default, null) }));
    }
    if ((0, lodash_1.includes)(exports.PLAYABLE_VIDEO_CARD_TYPES, type)) {
        return (react_1.default.createElement(inline_icon_1.default, { className: (0, classnames_1.default)(styles_scss_1.default.triangle, (_b = {},
                _b[styles_scss_1.default['with-url']] = thumbnailUrl,
                _b)), icon: react_1.default.createElement(TriangleIcon_1.default, null) }));
    }
    if (thumbnailUrl) {
        return null;
    }
    switch (type) {
        case types_1.VIDEO_CARD_TYPES.PRODUCT:
            return react_1.default.createElement(inline_icon_1.default, { className: styles_scss_1.default.icon, icon: react_1.default.createElement(TagIcon_1.default, null) });
        case types_1.VIDEO_CARD_TYPES.CUSTOM:
            return react_1.default.createElement(inline_icon_1.default, { className: styles_scss_1.default.icon, icon: react_1.default.createElement(SparkIcon_1.default, null) });
        default:
            return null;
    }
};
CardThumbnailPlaceholderIcon.propTypes = {
    type: prop_types_1.default.string,
    thumbnailUrl: prop_types_1.default.string,
    itemType: prop_types_1.default.string,
};
exports.default = CardThumbnailPlaceholderIcon;
//# sourceMappingURL=thumbnail-placeholder-icon.js.map